import { ITemplate } from '@entities/card/types';

export const StyledTemplate = ({
    template,
    ind,
}: {
    template: ITemplate;
    ind: number;
}): JSX.Element => {
    const isBlock = template?.state === 1;
    let bgColor = template?.cpColorBg ? template?.cpColorBg : '#efefef';
    let textColor = template?.cpColorText ? template.cpColorText : '#999';
    let borderColor = template?.cpColorBorder
        ? template?.cpColorBorder
        : '#aaa';

    if (isBlock) {
        bgColor = '#efefef';
        textColor = '#999';
        borderColor = '#aaa';
    }

    return (
        <span
            title={isBlock ? 'Карта заблокирована' : template?.displayName}
            style={{
                background: bgColor,
                border: '1px solid ' + borderColor,
                color: textColor,
                display: 'inline-block',
                padding: '3px 4px',
                boxSizing: 'border-box',
                borderRadius: '3px',
                fontSize: '13px',
                margin: '2px',
                lineHeight: '1em',
            }}
            key={ind}
        >
            {template?.name ? template?.name.toUpperCase() : ''}
        </span>
    );
};
